import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Flex, notification } from "antd";
import dayjs from "dayjs";

import { POST } from "../../../../providers/useAxiosQuery";
import PageScoreCardFormContext from "./PageScoreCardFormContext";
import notificationErrors from "../../../../providers/notificationErrors";
import currentLocation from "../../../../providers/currentLocation";
import { checkNetworkStatus } from "../../../../providers/useCapacitorStorage";

export default function FormContentSend() {
	const { dataSource, dataQuestions, answers } = useContext(
		PageScoreCardFormContext
	);

	const navigate = useNavigate();

	const [isLoadingSurvey, setIsLoadingSurvey] = useState(false);

	const { mutate: mutateSurvey } = POST(
		`api/form_question_answer_batch_pub`,
		"form_question_answer_single_store"
	);

	const onFinishPreview = async () => {
		setIsLoadingSurvey(true);

		let dataAnswers = [];

		Object.keys(answers).forEach((key) => {
			let q_id = key.split("_")[1];
			let question = dataQuestions.find((item) => item.id === Number(q_id));
			if (question) {
				dataAnswers.push({
					user_id: "",
					form_id: dataSource.id,
					form_question_category_id: question.form_question_category_id,
					form_question_id: question.id,
					answer: answers[key],
				});
			}
		});

		const currentLocations = await currentLocation();

		let coords =
			currentLocations && currentLocations.coords
				? currentLocations.coords
				: {};

		try {
			let resCheckNetworkStatus = await checkNetworkStatus();

			if (resCheckNetworkStatus?.connected) {
				// connected
				mutateSurvey(
					{
						answer_list: dataAnswers,
						batch: {
							user_id: "",
							form_id: dataSource.id,
							latitude: coords.latitude,
							longitude: coords.longitude,
							accuracy: coords.accuracy,
							altitude: coords.altitude,
							heading: coords.heading,
							altitude_accuracy: coords.altitudeAccuracy,
							speed: coords.speed,
							date_end_answer: dayjs().format("YYYY-MM-DD HH:mm:ss"),
							date_start_answer: dayjs().format("YYYY-MM-DD HH:mm:ss"),
						},
					},
					{
						onSuccess: (res2) => {
							if (res2.success) {
								notification.success({
									message: "Scorecard",
									description: res2.message,
								});
								localStorage.setItem("scorecard_batch_id", res2.batch_id);
								localStorage.setItem("scorecard_batch_code", res2.batch_code);
								navigate("/scorecard/form/send");
							} else {
								notification.error({
									message: "Scorecard",
									description: res2.message,
								});
							}
							setIsLoadingSurvey(false);
						},
						onError: (err) => {
							setIsLoadingSurvey(false);
							notificationErrors(err);
						},
					}
				);
			} else {
				setIsLoadingSurvey(false);
				notification.error({
					message: "Survey",
					description:
						"Connection lost, please check your internet connection.",
				});
			}
		} catch (error) {
			notification.error({
				message: "Survey",
				description: "Connection lost, please check your internet connection.",
			});
			setIsLoadingSurvey(false);
		}
	};

	return (
		<>
			<video
				src="/assets/Joya_Life_video_background.mp4"
				autoPlay
				muted
				loop
				playsInline
			>
				Your browser does not support the video tag.
			</video>
			<div className="content-title send">
				Your Joya Life Scorecard is Ready!
			</div>
			<div className="content-description send">
				<div>
					Curious about what your results say<sup>__</sup>and how to bring more
					balance into your life?
				</div>
				<br />
				<div>
					Share your email and we'll send your scorecard along with a few tools
					to support your growth.
				</div>
			</div>
			<Flex gap={15} justify="center">
				<Button
					type="primary"
					className="btn-main-primary mt-20"
					onClick={() => onFinishPreview()}
					loading={isLoadingSurvey}
				>
					SEND MY SCORECARD
				</Button>
			</Flex>
		</>
	);
}
